// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
  width: 1.5rem;
  height: 1.5rem;
  border-top-color: #444;
  border-left-color: #444;

  /* Additional spinner styles */
  animation: spinner 400ms linear infinite;
  border-bottom-color: transparent;
  border-right-color: transparent;
  border-style: solid;
  border-width: 2px;
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
}

@keyframes spinner {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.spinner-large {
  width: 5rem;
  height: 5rem;
  border-width: 6px;
}

.spinner-slow {
  animation: spinner 1s linear infinite;
}

.spinner-blue {
  border-top-color: #09d;
  border-left-color: #09d;
}
`, "",{"version":3,"sources":["webpack://./assets/css/spinner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;;EAEvB,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB","sourcesContent":[".spinner {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-top-color: #444;\n  border-left-color: #444;\n\n  /* Additional spinner styles */\n  animation: spinner 400ms linear infinite;\n  border-bottom-color: transparent;\n  border-right-color: transparent;\n  border-style: solid;\n  border-width: 2px;\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n@keyframes spinner {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.spinner-large {\n  width: 5rem;\n  height: 5rem;\n  border-width: 6px;\n}\n\n.spinner-slow {\n  animation: spinner 1s linear infinite;\n}\n\n.spinner-blue {\n  border-top-color: #09d;\n  border-left-color: #09d;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
